import Vue from 'vue'
import App from './App.vue'

import '@/compositions/filters'
import '@/compositions/directives'
import "@/commons"

import components from '@/components'
import vuetify from '@/plugins/vuetify'
import router from '@/routers/index'
import store from '@/stores'

Vue.config.productionTip = false;
Vue.prototype.console = window.console;

new Vue({
	vuetify,
	router,
	store,
	components,
	render: h => h(App)
}).$mount('#app')
